// extracted by mini-css-extract-plugin
export var container = "_8l-0";
export var icon = "_8l-1";
export var text = "_8l-2";